// APP ENV constants

// Subdomain Prefixes
export const DEV_SUBDOMAIN_PREFIX = 'dev';
export const STAGING_SUBDOMAIN_PREFIX = 'staging';
export const DEV_APEX_DOMAIN = 'dev-berkeleypayment';
export const STAGING_APEX_DOMAIN = 'stage-berkeleypayment';